import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextArea from 'mineral-ui/TextArea';
import { Select } from 'mineral-ui/Select';
import styled from '@emotion/styled';
import Button from './Button';
import ButtonGroup from './ButtonGroup';
import { Box, Flex } from './Structure';

const propTypes = {
  autoSize: PropTypes.bool,
  defaultValue: PropTypes.string,
  onCancel: PropTypes.func, // Called when user cancels editting
  onPreview: PropTypes.func, // Called when user requests a preview of the contents rendered
  onSave: PropTypes.func, // Called with updated text when user saves
  onChange: PropTypes.func, // This will override the handle change in this component.
  onSelectChange: PropTypes.func, // This will handle the selection of the content type.
  placeholder: PropTypes.string,
  rows: PropTypes.number,
  size: PropTypes.string,
  value: PropTypes.string,
  displayTypeSelect: PropTypes.bool,
  dropDownOptions: PropTypes.arrayOf(PropTypes.object),
  indexOfContentType: PropTypes.number,
};
const defaultProps = {
  autoSize: false,
  defaultValue: '',
  onCancel: undefined,
  onPreview: undefined,
  onSave: undefined,
  onChange: undefined,
  onSelectChange: undefined,
  placeholder: undefined,
  rows: undefined,
  size: undefined,
  value: undefined,
  displayTypeSelect: false,
  dropDownOptions: null,
  indexOfContentType: null,
};

/* Warning: autoSize can sometimes not work perfectly and cut off a few lines of text.
 * It is recommended that unless you are working in a tight space, you use a fixed size.
 */
export default class TextEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // If this is used as uncontrolled component, store the text ourselves
      text: '',
    };
  }

  componentDidMount() {
    const { defaultValue } = this.props;
    this.setState({ text: defaultValue });
  }

  handleChange = (event) => {
    const { target: { value } } = event;
    const { onChange } = this.props;
    this.setState({ text: value });
    if (onChange) {
      onChange(value);
    }
  }

  render() {
    const {
      autoSize, onCancel, onPreview, onSave, onSelectChange, placeholder, rows, size, value,
      displayTypeSelect, dropDownOptions, indexOfContentType,
    } = this.props;

    const ListElement = styled.div`
      margin-left:auto;
      display: block-inline;
    `;

    let selectElement;
    if (displayTypeSelect) {
      selectElement = (
        <ListElement>
          <Select
            name="type"
            defaultSelectedItem={dropDownOptions[indexOfContentType]}
            data={dropDownOptions}
            onChange={item => onSelectChange({ target: { name: 'type', value: item.value } })}
          />
        </ListElement>
      );
    } else {
      selectElement = '';
    }
    const { text } = this.state;
    return (
      <Box marginVertical="0.5em">
        <TextArea
          autoFocus
          autoSize={autoSize}
          type="text"
          onChange={this.handleChange}
          placeholder={placeholder}
          rows={rows}
          size={size}
          value={value || text}
        />
        <Flex marginTop="1em">
          {selectElement}
          <ButtonGroup>
            {onPreview
              && (<Button minimal onClick={() => onPreview(value || text)}>Preview</Button>)}
            {onCancel && <Button onClick={onCancel}>Cancel</Button>}
            {onSave && <Button primary onClick={() => onSave(value || text)}>Save</Button>}
          </ButtonGroup>
        </Flex>
      </Box>
    );
  }
}

TextEditor.propTypes = propTypes;
TextEditor.defaultProps = defaultProps;
